// db.js - IndexedDB database setup using Dexie
import Dexie from "dexie";

export const db = new Dexie("JournalingApp");

// Define database schema
db.version(1).stores({
  documents: "++id, title, createdAt",
  blocks: "++id, documentId, position, blockType, content, createdAt",
});

// Initialize the database
export async function initDatabase() {
  try {
    // Open the database
    await db.open();
    console.log("Database opened successfully");

    // Check if we need to populate with initial data
    const documentCount = await db.documents.count();

    if (documentCount === 0) {
      console.log("Creating initial document");

      // Create a default document
      const docId = await db.documents.add({
        title: "My First Journal",
        createdAt: new Date(),
      });

      // Add a welcome block
      await db.blocks.add({
        documentId: docId,
        content:
          "Welcome to your journal! Press Shift+Enter to create a new block.",
        blockType: "text",
        position: 0,
        createdAt: new Date(),
      });
    }

    return true;
  } catch (error) {
    console.error("Failed to initialize database:", error);
    return false;
  }
}

// Export database accessor functions
export const documentStore = {
  async getAll() {
    return await db.documents.toArray();
  },

  async get(id) {
    return await db.documents.get(id);
  },

  async create(title) {
    return await db.documents.add({
      title,
      createdAt: new Date(),
    });
  },

  async update(id, data) {
    return await db.documents.update(id, data);
  },

  async delete(id) {
    return await db.documents.delete(id);
  },
};

export const blockStore = {
  async getByDocument(documentId) {
    return await db.blocks
      .where("documentId")
      .equals(documentId)
      .sortBy("position");
  },

  async create(data) {
    return await db.blocks.add({
      ...data,
      createdAt: new Date(),
    });
  },

  async update(id, data) {
    return await db.blocks.update(id, data);
  },

  async delete(id) {
    return await db.blocks.delete(id);
  },

  async deleteByDocument(documentId) {
    return await db.blocks.where("documentId").equals(documentId).delete();
  },
};
